import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { Sidebar } from '../../layouts/Sidebar';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';
import brand from './index';

const ColorManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [image, setImage] = useState<any>({});

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.color.basic + (paramId || '')).post(tools.extractor(form, ['title', 'code', 'description']));

    if (res.code != 200) {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

      if (res.code == 200) {
        Swal.fire({
          title: 'موفق',
          text: `رنگ با موفقیت ${paramId ? 'ویرایش' : 'ایجاد'} شد`,
          icon: 'success',
          confirmButtonText: 'متوجه شدم',
          didClose() {
            navigate('/color')
          }
        });
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.color.single + paramId, true).get();

    if (res.code == 200) {
      setForm({
        title: res.data?.title,
        code: res.data?.code
      });
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    paramId && fetchItem();
  }, []);
  console.log(form);
  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
           {paramId ? 'ویرایش ' : 'ایجاد '}رنگ
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه رنگ</h1>
             <h1 className="dashBoardTitle">{paramId ? 'ویرایش' : 'ایجاد'} رنگ </h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate('/color/')}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات رنگ</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setForm(prev => ({
              ...prev,
              title: input.target.value
            }))} value={form.title}/>
            <label className="sideBarTitle" htmlFor="infoAmount">کد</label>
            <input className="addInput" id="infoTitle" type="color" onChange={(input: any) => setForm(prev => ({
              ...prev,
              code: input.target.value
            }))} value={form.code}/>
          </form>
        </section>
      </main>
      </body>
    </>
  );
};
export default ColorManage;